<template>
  <div>
    <div class="label">{{ r.label }}</div>
    <el-input
      type="textarea"
      :autosize="{ minRows: 10 }"
      v-model="r.value"
      :placeholder="r.remark"
    />
  </div>
</template>
<style scoped>
.label {
  margin-top: 1rem;
}
</style>
<script>
export default {
  props: {
    r: Object,
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {},
};
</script>
